const Global = {
  goalConfigInfo: [],
  commonConfigInfo: [],
  userAgeInfo: {},
};

export default Global;
